import { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { toast } from "sonner";
import { Pencil } from "lucide-react";

const inp = "w-full border border-brand-gold-light/50 rounded px-3 py-2 text-sm bg-white outline-none focus:border-brand-gold";

export default function ProgramManager() {
  const [items, setItems] = useState([]);
  const [editing, setEditing] = useState(null);

  const load = () => api.get("/admin/programs").then(({ data }) => setItems(data)).catch(() => {});
  useEffect(() => { load(); }, []);

  const listToText = (v) => (Array.isArray(v) ? v.join("\n") : v || "");
  const textToList = (v) => (typeof v === "string" ? v.split("\n").map((x) => x.trim()).filter(Boolean) : v);

  const save = async () => {
    const payload = {
      ...editing,
      for_whom: textToList(editing.for_whom), gains: textToList(editing.gains),
      how_it_works: textToList(editing.how_it_works), modules: textToList(editing.modules),
      faqs: editing.faqs || [],
    };
    try {
      await api.put(`/admin/programs/${editing.id}`, payload);
      toast.success("Program güncellendi."); setEditing(null); load();
    } catch { toast.error("Kayıt başarısız."); }
  };

  return (
    <div data-testid="admin-programs">
      <h1 className="font-serif text-4xl text-brand-green mb-6">Program Yönetimi</h1>
      <div className="grid md:grid-cols-2 gap-5">
        {items.map((p) => (
          <div key={p.id} data-testid={`program-row-${p.slug}`} className="bg-brand-offwhite border border-brand-gold-light/40 rounded-sm p-6">
            <div className="flex justify-between items-start">
              <div>
                <h3 className="font-serif text-2xl text-brand-green">{p.name}</h3>
                <p className="text-brand-text/60 text-sm mt-1">{p.tagline}</p>
              </div>
              <button onClick={() => setEditing({ ...p, for_whom: listToText(p.for_whom), gains: listToText(p.gains), how_it_works: listToText(p.how_it_works), modules: listToText(p.modules) })}
                data-testid={`program-edit-${p.slug}`} className="text-brand-green"><Pencil size={18} /></button>
            </div>
          </div>
        ))}
      </div>

      {editing && (
        <div className="fixed inset-0 bg-brand-green/50 flex items-start justify-center z-50 p-6 overflow-y-auto" onClick={() => setEditing(null)}>
          <div className="bg-brand-offwhite rounded-sm p-8 max-w-2xl w-full my-8" onClick={(e) => e.stopPropagation()}>
            <h3 className="font-serif text-2xl text-brand-green mb-5">{editing.name}</h3>
            <div className="space-y-4">
              <F l="Başlık (name)"><input value={editing.name} onChange={(e) => setEditing({ ...editing, name: e.target.value })} className={inp} /></F>
              <F l="Slogan (tagline)"><input value={editing.tagline} onChange={(e) => setEditing({ ...editing, tagline: e.target.value })} className={inp} /></F>
              <F l="Hero alt metin"><textarea value={editing.hero_subtitle} onChange={(e) => setEditing({ ...editing, hero_subtitle: e.target.value })} className={inp} rows={2} /></F>
              <F l="Neden var?"><textarea value={editing.why} onChange={(e) => setEditing({ ...editing, why: e.target.value })} className={inp} rows={3} /></F>
              <F l="Kimler için? (satır satır)"><textarea value={editing.for_whom} onChange={(e) => setEditing({ ...editing, for_whom: e.target.value })} className={inp} rows={3} /></F>
              <F l="Ne kazandırır? (satır satır)"><textarea value={editing.gains} onChange={(e) => setEditing({ ...editing, gains: e.target.value })} className={inp} rows={3} /></F>
              <F l="Nasıl işler? (satır satır)"><textarea value={editing.how_it_works} onChange={(e) => setEditing({ ...editing, how_it_works: e.target.value })} className={inp} rows={3} /></F>
              <F l="Modüller (satır satır)"><textarea value={editing.modules} onChange={(e) => setEditing({ ...editing, modules: e.target.value })} className={inp} rows={3} /></F>
              <F l="Yaklaşım"><textarea value={editing.approach} onChange={(e) => setEditing({ ...editing, approach: e.target.value })} className={inp} rows={2} /></F>
            </div>
            <div className="flex gap-3 mt-6">
              <button onClick={save} data-testid="program-save" className="bg-brand-gold text-brand-offwhite px-6 py-2.5 rounded-sm text-sm">Kaydet</button>
              <button onClick={() => setEditing(null)} className="border border-brand-gold-light px-6 py-2.5 rounded-sm text-sm">İptal</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
function F({ l, children }) { return <div><label className="block text-sm font-medium text-brand-text mb-1">{l}</label>{children}</div>; }
